// extracted by mini-css-extract-plugin
module.exports = {"containerWithTickMark":"WindForecastData_containerWithTickMark__ndbep","windReadings":"WindForecastData_windReadings__Gihyx"};